import { assetLoader, audioPlayer, flump } from "../PhaserExtension";
import * as States from "./States";
import BaseState from "./BaseState";
import FlumpButton from "../general/objects/FlumpButton";
import StaticText from "../general/objects/StaticText";
import * as GameModel from "../models/GameModel";
import FlumpObject from "../general/objects/FlumpObject";
import Promise from "../../node_modules/promise-polyfill";
import PostgameGrover from "../postgame/objects/PostgameGrover";

export default class PostGameState extends BaseState {
    preload()
    {
        this.game.load.onFileComplete.add(this.onFileComplete, this);
        assetLoader.preloadAssetPacks(this.game, ["postGame"]);
        super.preload();
    }

    onFileComplete(progress, cacheKey, success, totalLoaded, totalFiles)
    {
        if(cacheKey == "postGameConfig")
        {
            this.config = this.game.cache.getJSON("postGameConfig");

            this.promises = [];
            this.pdfDataRequest('GET', this.config.variables.pdfKit.font, true);
            this.pdfDataRequest('GET', this.config.variables.pdfKit.pncImage.imageLocation[+GameModel.data.english], true);
            this.pdfDataRequest('GET', this.config.variables.pdfKit.sesameImage.imageLocation[+GameModel.data.english], true);
            for(let i = 0; i < GameModel.data.drawHistory.length; i++)
            {
                // load images through xhr requests to get the Array buffer data for each image
                // it seems phaser strips out the necessary meta data out of its array buffers for the images
                this.pdfDataRequest('GET', GameModel.data.drawHistory[i].outline, true);
            }

            // after all images have completed loading, create the pdf docuement
            Promise.all(this.promises).then(values => {
                let pdfConfig = this.config.variables.pdfKit;
                let doc = new PDFDocument({ layout: pdfConfig.pageOrientation, autoFirstPage: false });
                doc.font(values[0].target.response);
                doc.info['Title'] = "StoryCirclePrintout";

                let stream = doc.pipe(blobStream());
                // add the content to each page
                for (let i = 3; i < values.length; i++)
                {
                    doc.addPage({ layout: pdfConfig.pageOrientation });
                    this.addPDFPageContent(doc, values[i].target.response, GameModel.data.drawHistory[i - 3], pdfConfig, i - 3, values[1].target.response, values[2].target.response);
                }

                doc.end();

                stream.on('finish', () => {
                    this.pdfURL = stream.toBlobURL('application/pdf');
                    this.pdfBlob = stream.toBlob('application/pdf');

                    if (this.printButton)
                    {
                        this.printButton.alpha = 1;
                        this.printButton.inputEnabled = true;
                    }
                });
            }).catch(error =>{
                console.error("ERROR", error);
            });

            this.game.load.onFileComplete.remove(this.onFileComplete, this);
        }
    }

    pdfDataRequest(method, url)
    {
        let promise = new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = resolve;
            xhr.onerror = reject;
            // for ie11 support, responseType must be set after open is called
            xhr.open(method, url, true);
            xhr.responseType = "arraybuffer";
            xhr.send();
        });

        this.promises.push(promise);
        return promise;
    }

    create()
    {
        window.onerror = function(e, s, l, c, er)
        {
            this.e = e;
            this.l = l;
        }.bind(this);

        audioPlayer.setupChannels(this.config.sounds.channels);
        audioPlayer.play(this.game, this.config.sounds.music);
        flump.addLibrary(this.game, "storyCircleFlump", "assets/storyCircle/flump/");

        let background = new Phaser.Sprite(this.game, 0, 0, this.config.assets.background.display.key);
        this.backgroundLayer.add(background);

        this.grover = new PostgameGrover(this.game, this.config.assets.grover, "groverFlump");
        this.maingroundLayer.add(this.grover);

        this.replayButton = new FlumpButton(this.game, this.config.assets.replayButton, "mainFlump");
        this.replayButton.onClicked.addOnce(this.onReplay, this);
        this.maingroundLayer.add(this.replayButton);

        this.printButton = new FlumpButton(this.game, this.config.assets.printButton, "mainFlump");
        this.printButton.onClicked.add(this.onPrint, this);
        this.maingroundLayer.add(this.printButton);

        this.timeout = this.game.time.create(false);
        this.timeout.loop(Phaser.Timer.SECOND * 14, this.onTimeout, this);

        let muppets = this.config.assets.muppets;
        for(let i = 0; i < muppets.length; i++)
        {
            let muppet = new FlumpObject(this.game, muppets[i], "storyCircleFlump");
            this.backgroundLayer.add(muppet);
        }

        let overlayGlow = new FlumpObject(this.game, this.config.assets.overlay, "storyCircleFlump");
        this.backgroundLayer.add(overlayGlow);

        if(!this.pdfURL)
        {
            this.printButton.alpha = 0.5;
            this.printButton.inputEnabled = false;
        }

        this.timeoutCount = 0;
        this.timeoutFiredTime = 0;
        GameModel.data.currentStateName = "End Screen";

        super.create();
    }

    onTransitionInComplete()
    {
        audioPlayer.play(this.game, this.config.sounds.intro, this.onIntroComplete, this);
        super.onTransitionInComplete();
    }

    onIntroComplete()
    {
        this.game.time.events.add(Phaser.Timer.SECOND * 0.5, this.onDelayComplete, this);
    }

    onDelayComplete()
    {
        this.timeout.start();
        this.onTimeout();
    }

    onTimeout()
    {
        audioPlayer.play(this.game, Phaser.ArrayUtils.getRandomItem(this.config.sounds.timeoutArray));

        if(this.timeoutCount == 0)
        {
            this.timeoutFiredTime = Date.now();
        }
        this.timeoutCount += 1;
        GameModel.sendEvent("TimeoutPlay", "End Screen_Number_" + GameModel.fixNumber(this.timeoutCount));
    }

    onReplay()
    {
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "End Screen", Date.now() - this.timeoutFiredTime);
        }
        this.timeoutCount = 0;

        this.transistionOut();
    }

    onPrint()
    {
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "End Screen", Date.now() - this.timeoutFiredTime);
        }
        this.timeoutCount = 0;

        if(!this.pdfURL)
        {
            return;
        }
        this.pdfBlob.name = "SesameStreetStoryCircle";

        if (window.navigator && window.navigator.msSaveOrOpenBlob)
        {
            window.navigator.msSaveOrOpenBlob(this.pdfBlob);
        }
        else if(navigator.userAgent.match('CriOS'))
        {
            var reader = new FileReader();
            reader.onload = function(e)
            {
                window.open(reader.result);
            }
            reader.readAsDataURL(this.pdfBlob);
        }
        else
        {
            window.open(this.pdfURL, "_blank");
        }

        GameModel.data.pdfsDownloaded += 1;
    }

    onTransitionOutComplete()
    {
        GameModel.data.storyKey = "";
        GameModel.data.drawHistory = [];
        GameModel.data.turn = "";
        GameModel.data.lastPlayer = 1;
        GameModel.data.lastMuppet = -1;
        audioPlayer.stopChannel("VO");
        this.game.state.start(States.STORYCIRCLE);
    }

    addPDFPageContent(doc, image, pageData, config, pageIndex, pncImage, sesameImage)
    {
        doc.image(
            image,
            config.storyImage.imagePosition[Phaser.Math.clamp(pageIndex, 0, config.storyImage.imagePosition.length-1)].x,
            config.storyImage.imagePosition[Phaser.Math.clamp(pageIndex, 0, config.storyImage.imagePosition.length-1)].y,
            { scale: config.storyImage.imageScale }
        );
        if(pageIndex == 0)
        {
            doc.image(
                pncImage,
                config.pncImage.imagePosition.x,
                config.pncImage.imagePosition.y,
                {scale: config.pncImage.imageScale}
            );
            doc.image(
                sesameImage,
                config.sesameImage.imagePosition.x,
                config.sesameImage.imagePosition.y,
                {scale: config.sesameImage.imageScale}
            );
        }
        for(var i = 0; i < config.text.length; i++)
        {
            var text = config.text[i].text[+GameModel.data.english];
            switch(i)
            {
                case 0:
                    if(pageData.titleText != null)
                    {
                        text = pageData.titleText[+GameModel.data.english];
                    }
                    else
                    {
                        if(pageIndex == 0)
                            console.warn("pageData.titleText does not exist, please add to the storyCircle config!");
                    }
                    break;
                case 1:
                    if(pageIndex != 0)
                    {
                        text = "";
                    }
                    else
                    {
                        doc.page.margins.bottom = 0;
                    }
                    break;
                case 2:
                    text = pageData.storyText[+GameModel.data.english];
                    break;
                case 3:
                    text = text.replace('*', pageIndex + 1);
                    break;
                case 4:
                    if(pageIndex != 0)
                        text = "";
                    break;
            }
            doc.fontSize(config.text[i].fontSize)
            doc.text(
                text,
                config.text[i].textPosition[Phaser.Math.clamp(pageIndex, 0, config.text[i].textPosition.length-1)].x,
                config.text[i].textPosition[Phaser.Math.clamp(pageIndex, 0, config.text[i].textPosition.length-1)].y,
                {
                    width: config.text[i].textWidth[Phaser.Math.clamp(pageIndex, 0, config.text[i].textWidth.length-1)],
                    align: config.text[i].textAlignment[Phaser.Math.clamp(pageIndex, 0, config.text[i].textAlignment.length-1)],
                    lineGap: config.text[i].lineGap
                }
            );
        }
    }

    shutdown() {
        flump.removeLibrary("storyCircleFlump");
        assetLoader.unloadAssetPacks(this.game, ["postGame"]);
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        delete this.grover;
        this.timeout.destroy();
        delete this.timeout;
        delete this.promises;
        delete this.printButton;
        delete this.replayButton;

        if(this.pdfBlob) delete this.pdfBlob;
        if(this.pdfURL) delete this.pdfURL;
        super.shutdown();
    }
}
